export default "__VITE_ASSET__bf5aae61__"